import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import { toast } from 'react-toastify';
import { adminMainUrl } from '../../../../../Config';
import { useNavigate } from 'react-router-dom';
import { customStyles } from '../../../../../HelperFunctions';
import Select from 'react-select';
import { getCityListByState, getGSTStateListByCountry, getOriginCountry, getStateListByCountry } from '../../../../../Redux/action/MasterAction';
import { useDispatch, useSelector } from 'react-redux';
import { getCountry } from '../../../../../Redux/action/Admin/EmployeeMasterAction';


const AddAddress = ({
    token,
    user_id,
    b64id,
    show,
    handleClose,
    refreshAddress,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);

    const initialValues = {
        is_default: false,
        contact_person_name: "",
        // branch_id: 0,
        // branch_name: "",
        address_one: "",
        address_two: "",
        country_id: 0,
        state_id: 0,
        city_id: 0,
        pincode: "",
        gst_number: "",
        gst_country_id: 0,
        gst_state_id: 0,
        gst_state_code: "",
        phone: "",
        // mobile: "",
        // fax: "",
        email_one: "",
        email_two: "",
        // website: "",
        is_gst_exempted: false,
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }

                let airline_id = atob(b64id);
                if (airline_id) {
                    values.airline_id = airline_id
                } else {
                    toast.error("Can't add address.");
                    return;
                }
                axios.post(`${adminMainUrl}/api/master/airline/address/create`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            refreshAddress();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [GSTStateOptions, setGSTStateOptions] = useState([]);


    const {
        loadingMasterStateByCountryList,
        MasterStateByCountryList,
        MasterStateByCountryListError,

        loadingMasterStateByGSTCountryList,
        MasterStateByGSTCountryList,
        MasterStateByGSTCountryListError,

        loadingOriginCountry,
        originCountryData,

        loadingMasterCityByStateList,
        MasterCityByStateList,
        MasterCityByStateListError
    } = useSelector(state => state.MasterReducer);

    useEffect(() => {
        if (b64id) {
            dispatch(getOriginCountry());
        }
    }, [b64id])

    useEffect(() => {
        if (formik.values.country_id) {
            dispatch(getStateListByCountry(token, user_id, formik.values.country_id));
        } else {
            setStateOptions([]);
        }
    }, [formik.values.country_id]);

    useEffect(() => {
        if (formik.values.state_id) {
            dispatch(getCityListByState(token, user_id, formik.values.state_id));
        } else {
            setStateOptions([]);
        }
    }, [formik.values.state_id]);

    useEffect(() => {
        if (formik.values.gst_country_id) {
            dispatch(getGSTStateListByCountry(token, user_id, formik.values.gst_country_id));
        } else {
            setStateOptions([]);
        }
    }, [formik.values.gst_country_id]);

    useEffect(() => {
        if (MasterStateByCountryList) {
            let arr = [];
            MasterStateByCountryList.map(v => { arr.push({ value: v.id, label: v.name }) });
            setStateOptions(arr);
        } else {
            setStateOptions([]);
        }
    }, [MasterStateByCountryList]);

    useEffect(() => {
        if (MasterStateByGSTCountryList) {
            let arr = [];
            MasterStateByGSTCountryList.map(v => { arr.push({ value: v.id, label: v.name }) });
            setGSTStateOptions(arr);
        } else {
            setGSTStateOptions([]);
        }
    }, [MasterStateByGSTCountryList]);

    useEffect(() => {
        if (MasterCityByStateList) {
            let arr = [];
            MasterCityByStateList.map(v => { arr.push({ value: v.id, label: v.name }) });
            setCityOptions(arr);
        } else {
            setCityOptions([]);
        }
    }, [MasterCityByStateList]);

    useEffect(() => {
        if (originCountryData) {
            let arr = [];
            originCountryData.map(v => { arr.push({ value: v.id, label: v.name }) });
            setCountryOptions(arr);
        } else {
            setCountryOptions([]);
        }
    }, [originCountryData]);

    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add Address</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit} >
                        <div className="row">
                            <div className="col-md-12">
                                <input
                                    className='me-2'
                                    type='checkbox'
                                    name="is_default"
                                    onChange={(e) => { formik.setFieldValue("is_default", e.target.checked) }}
                                    checked={formik.values.is_default}
                                />
                                <label htmlFor="is_default" className='form-label mb-0'>
                                    Default Address
                                </label>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="contact_person_name" className='form-label mb-0'>
                                    Contact Person
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="contact_person_name"
                                    name='contact_person_name'
                                    value={formik.values.contact_person_name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />

                            </div>
                            {/* <div className="col-md-6">
                                <label htmlFor="branch_name" className='form-label mb-0'>
                                    Branch Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="branch_name"
                                    name='branch_name'
                                    value={formik.values.branch_name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div> */}
                            <div className="col-md-6">
                                <label htmlFor="address_one" className='form-label mb-0'>
                                    Address 1
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="address_one"
                                    name='address_one'
                                    value={formik.values.address_one}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />

                            </div>
                            <div className="col-md-6">
                                <label htmlFor="address_two" className='form-label mb-0'>
                                    Address 2
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="address_two"
                                    name='address_two'
                                    value={formik.values.address_two}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="country_id" className='form-label mb-0'>
                                    Country
                                </label>

                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select
                                        className='custom-selector'
                                        placeholder="Select an option"
                                        options={countryOptions}
                                        styles={customStyles}
                                        name="country_id"
                                        onChange={option => {
                                            formik.setFieldValue('country_id', option.value);
                                            formik.setFieldValue('state_id', 0);
                                            formik.setFieldValue('city_id', 0);
                                        }}
                                        value={formik.values.country_id ? countryOptions.find(option => option.value == formik.values.country_id || null) : null}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="state_id" className='form-label mb-0'>
                                    State
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select
                                        className='custom-selector'
                                        placeholder="Select an option"
                                        options={stateOptions}
                                        styles={customStyles}
                                        name="state_id"
                                        onChange={option => {
                                            formik.setFieldValue('state_id', option.value);
                                            formik.setFieldValue('city_id', 0);
                                        }}
                                        value={formik.values.state_id ? stateOptions.find(option => option.value == formik.values.state_id || null) : null}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="city_id" className='form-label mb-0'>
                                    City
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select
                                        className='custom-selector'
                                        placeholder="Select an option"
                                        options={cityOptions}
                                        styles={customStyles}
                                        name="city_id"
                                        onChange={option => {
                                            formik.setFieldValue('city_id', option.value);
                                        }}
                                        value={formik.values.city_id ? cityOptions.find(option => option.value == formik.values.city_id || null) : null}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="pincode" className='form-label mb-0'>
                                    Pincode
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="pincode"
                                    name='pincode'
                                    value={formik.values.pincode}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={6}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}
                                />
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="gst_number" className='form-label mb-0'>
                                    GST Number
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="gst_number"
                                    name='gst_number'
                                    value={formik.values.gst_number}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="gst_country_id" className='form-label mb-0'>
                                    GST Country
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">

                                    <Select
                                        className='custom-selector'
                                        placeholder="Select an option"
                                        options={countryOptions}
                                        styles={customStyles}
                                        name="gst_country_id"
                                        onChange={option => {
                                            formik.setFieldValue('gst_country_id', option.value);
                                            formik.setFieldValue('gst_state_id', 0);
                                        }}
                                        value={formik.values.gst_country_id ? countryOptions.find(option => option.value == formik.values.gst_country_id || null) : null}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="gst_state_id" className='form-label mb-0'>
                                    GST State
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select
                                        className='custom-selector'
                                        placeholder="Select an option"
                                        options={GSTStateOptions}
                                        styles={customStyles}
                                        name="gst_state_id"
                                        onChange={option => {
                                            formik.setFieldValue('gst_state_id', option.value);
                                        }}
                                        value={formik.values.gst_state_id ? GSTStateOptions.find(option => option.value == formik.values.gst_state_id || null) : null}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="phone" className='form-label mb-0'>
                                    Phone
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="phone"
                                    name='phone'
                                    value={formik.values.phone}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={15}
                                />
                            </div>
                            {/* <div className="col-md-6">
                                <label htmlFor="mobile" className='form-label mb-0'>
                                    Mobile
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="mobile"
                                    name='mobile'
                                    value={formik.values.mobile}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={10}
                                />
                            </div> */}
                            {/* <div className="col-md-6">
                                <label htmlFor="fax" className='form-label mb-0'>
                                    Fax
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="fax"
                                    name='fax'
                                    value={formik.values.fax}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={10}
                                />
                            </div> */}
                            <div className="col-md-6">
                                <label htmlFor="email_one" className='form-label mb-0'>
                                    Email 1
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="email_one"
                                    name='email_one'
                                    value={formik.values.email_one}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="email_two" className='form-label mb-0'>
                                    Email 2
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="email_two"
                                    name='email_two'
                                    value={formik.values.email_two}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div>
                            {/* <div className="col-md-6">
                                <label htmlFor="website" className='form-label mb-0'>
                                    Website
                                </label>
                                <input
                                    type='text'
                                    className="form-control form-control-sm"
                                    id="website"
                                    name='website'
                                    value={formik.values.website}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div> */}

                            <div className="col-md-12">
                                <input
                                    className='me-2'
                                    type='checkbox'
                                    name="is_gst_exempted"
                                    onChange={(e) => { formik.setFieldValue("is_gst_exempted", e.target.checked) }}
                                    checked={formik.values.is_gst_exempted}
                                />
                                <label htmlFor="is_gst_exempted" className='form-label mb-0'>
                                    GST Exempted
                                </label>
                            </div>

                        </div>
                        <div className="row d-flex justify-content-end">
                            <div className="col-md-6 d-flex justify-content-end">
                                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default AddAddress